import { Accessor, createContext, useContext } from 'solid-js';

export interface MenuCtx {
  /** Currently selected item value (leaf or top-level without subitems). */
  selectedValue: Accessor<string | null>;
}

export const MenuContext = createContext<MenuCtx>();

export function useMenuContext(): MenuCtx {
  const ctx = useContext(MenuContext);
  if (!ctx) {
    throw new Error(
      'SideNavigation menu context is missing. Menu sub-components must render inside SideNavigation.'
    );
  }
  return ctx;
}
